import React from "react";
import { Card, Form, Row, Col, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const MissionVisionSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value
    });
  };

  const handleFileUpload = async (field, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleChange(field, res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Mission & Vision Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleChange('heading', e.target.value)}
                  placeholder="Enter heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={data.description}
                  onChange={(e) => handleChange('description', e.target.value)}
                  placeholder="Enter description"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Main Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] && handleFileUpload('mainImage', e.target.files[0])
                  }
                />
                {isUploading && (
                  <div className="text-muted small mt-1">
                    Uploading...
                  </div>
                )}
                {data.mainImage && (
                  <div className="mt-2">
                    <Image
                      src={data.mainImage}
                      alt="Preview"
                      thumbnail
                      style={{ maxWidth: "200px" }}
                    />
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Mission Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] && handleFileUpload('missionImage', e.target.files[0])
                  }
                />
                {data.missionImage && (
                  <div className="mt-2">
                    <Image
                      src={data.missionImage}
                      alt="Mission"
                      thumbnail
                      style={{ maxWidth: "150px" }}
                    />
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Vision Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] && handleFileUpload('visionImage', e.target.files[0])
                  }
                />
                {data.visionImage && (
                  <div className="mt-2">
                    <Image
                      src={data.visionImage}
                      alt="Vision"
                      thumbnail
                      style={{ maxWidth: "150px" }}
                    />
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </Card>
  );
};

export default MissionVisionSection;
